/**
 * Enum representing authentication and user session events.
 *
 * Usage:
 *   Event.Authentication.Login
 *   Event.Authentication.Logout
 *
 * These events are dispatched during user authentication flows
 * and session management operations.
 *
 * @author Matt Kenefick <matt@polymermallard.com>
 * @package Event
 * @project ChalkySticks
 */
export enum Authentication {
	Login = 'authentication:login',
	Logout = 'authentication:logout',
	LogoutRequest = 'logout:request',
	UserRefresh = 'authentication:user:refresh',
	UserUpdated = 'authentication:user:updated',
}
